import { render } from "./ChecklistCategory.vue?vue&type=template&id=d63d939e"
import script from "./ChecklistCategory.vue?vue&type=script&lang=js"
export * from "./ChecklistCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__